import { WindowLocation } from "@gatsbyjs/reach-router";
import { parse } from "query-string";

import { GatsbyPageProps } from "../types/gatsby";

export const isBrowser = () =>
  typeof document !== "undefined" && typeof window !== "undefined";

export const useQueryString = (
  location: GatsbyPageProps["location"] | WindowLocation
) => {
  return location ? parse(location.search) : {};
};

export const getPathFromLocation = (location: GatsbyPageProps["location"]) => {
  const pathname =
    typeof location?.pathname === "string"
      ? location.pathname.replace(/\/$/, "").split("/").pop()
      : "";
  return pathname;
};
